var P = Object.defineProperty, S = Object.defineProperties;
var A = Object.getOwnPropertyDescriptors;
var s = Object.getOwnPropertySymbols;
var d = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable;
var n = (o, r, e) => r in o ? P(o, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : o[r] = e, c = (o, r) => {
  for (var e in r || (r = {}))
    d.call(r, e) && n(o, e, r[e]);
  if (s)
    for (var e of s(r))
      l.call(r, e) && n(o, e, r[e]);
  return o;
}, u = (o, r) => S(o, A(r));
var y = (o, r) => {
  var e = {};
  for (var t in o)
    d.call(o, t) && r.indexOf(t) < 0 && (e[t] = o[t]);
  if (o != null && s)
    for (var t of s(o))
      r.indexOf(t) < 0 && l.call(o, t) && (e[t] = o[t]);
  return e;
};
import { jsx as a, jsxs as C } from "react/jsx-runtime";
import i from "../../../node_modules/prop-types/index.es.js";
import H from "react";
import L from "react-modal";
import * as T from "./style.es.js";
import { Modal as g, Body as k } from "./style.es.js";
import { Header as v } from "./Header/Header.es.js";
import { Footer as w } from "./Footer/Footer.es.js";
import { MODAL_SIZE as M } from "../../../constants/sizes.es.js";
const f = H.forwardRef((z, x) => {
  var m = z, {
    children: o,
    components: r = {},
    isOpen: e = !1,
    onBack: t,
    onRequestClose: p,
    primaryButtonProps: R,
    secondaryButtonProps: j,
    size: O = M.m,
    title: b = "",
    steps: h = [],
    activeStepIndex: B
  } = m, q = y(m, [
    "children",
    "components",
    "isOpen",
    "onBack",
    "onRequestClose",
    "primaryButtonProps",
    "secondaryButtonProps",
    "size",
    "title",
    "steps",
    "activeStepIndex"
  ]);
  return /* @__PURE__ */ a(L, u(c({ isOpen: e, onRequestClose: () => p(!1), ariaHideApp: !1 }, q), { children: /* @__PURE__ */ C(g, { size: O, ref: x, children: [
    /* @__PURE__ */ a(v, { title: b, onBack: t, onRequestClose: p, steps: h, activeStepIndex: B, components: r }),
    /* @__PURE__ */ a(k, { children: o }),
    /* @__PURE__ */ a(w, { onRequestClose: p, primaryButtonProps: R, secondaryButtonProps: j, components: r })
  ] }) }));
});
f.S = T;
f.displayName = "Modal";
f.propTypes = {
  children: i.node.isRequired,
  components: i.shape({
    LeftOfClose: i.func,
    SecondaryContent: i.func
  }),
  isOpen: i.bool.isRequired,
  onBack: i.func,
  onRequestClose: i.func.isRequired,
  primaryButtonProps: i.object,
  secondaryButtonProps: i.object,
  size: i.oneOf(Object.values(M)),
  title: i.string
};
export {
  f as Modal
};
//# sourceMappingURL=Modal.es.js.map
